import React, { Component } from 'react'
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import QuotationTable from './QuotationTable'

export default class QuotationTableWrapper extends Component {
    render() {
        return (
            <div>
                <Header />
                 <Menu/>
                <>
              <div className="content-wrapper">
              <QuotationTable/>
              </div>
              </>
              <Footer/>
            </div>
        )
    }
}